module.exports = "<div> <div ui-view></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/outputManage/baseData/goodsInfo/view/goodsInfo.html
// module id = /FgY
// module chunks = 0